import { useEffect } from 'react';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import {
	API_ENDPOINTS,
	customToast,
	Variants,
	route,
	WidthConstrainedContainer,
	checkTheme,
	Themes,
} from 'carrier-fe';
import axios from 'axios';

function Register() {
	const navigate = useNavigate();
	document.title = 'Registration';
	
	const [searchParams] = useSearchParams();
	const campaign = searchParams.get('campaign') ?? sessionStorage.getItem('campaign');
	
	useEffect(() => {
		if (window.location.pathname !== '/register') return;

		if (checkTheme(Themes.Toshiba)) navigate('/login');
		
		axios
			.post(route(API_ENDPOINTS.REGISTRATION.CREATE))
			.then((res) => {
				const baseUrl = `/register/${res.data.data.id}`;
				const url = campaign ? `${baseUrl}?campaign=${campaign}` : baseUrl;
				navigate(url);
			})
			.catch((err) =>
				customToast({
					variant: Variants.Danger,
					title:
						err?.response?.data?.message ||
						'Something went wrong...',
				})
			);
	}, []);

	return (
		<div
			className={'w-100 d-flex justify-content-center align-items-start bg-light p-3 p-md-4 p-lg-5'}
			style={{
				minHeight: '100vh',
				overflowX: 'hidden'
			}}
		>
			<WidthConstrainedContainer
				maxWidth={1000}
			>
				<Outlet />
			</WidthConstrainedContainer>
		</div>
	)
}

export default Register;
